import { Dropdown, MenuProps, Typography } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AssignFormulaToOrderModal from "../../../modals/AssignFormulaToOrderModal";
import ThreeDotsHrz from "./../../../graphics/svgs/threeDotsHrz.svg";

const OrderDropDown: React.FC<IOrderDropDown> = ({ order }) => {
  const navigate = useNavigate();
  const [showAssign, setShowAssign] = useState<boolean>(false);
  const orderOptions: MenuProps["items"] = [
    {
      key: "VIEW_DETAILS",
      label: (
        <Typography className="general-label-class">View Details</Typography>
      ),
    },
  ];
  if (order.processingDetails.formulaAssigned === null) {
    orderOptions.push({
      key: "ASSIGN_FORMULA",
      label: (
        <Typography className="general-label-class">Assign Formula</Typography>
      ),
    });
  }
  const handleMenuClick = (e: any) => {
    switch (e.key) {
      case "ASSIGN_FORMULA":
        setShowAssign(true);
        break;
      case "VIEW_DETAILS":
        navigate(`/user-orders/${order._id}`);
        break;
    }
  };
  return (
    <>
      {showAssign === true && (
        <AssignFormulaToOrderModal
          show={showAssign}
          handleClose={(e) => setShowAssign(false)}
          orderId={order._id}
          painLocations={order.painProfile.painLocations}
        />
      )}
      <Dropdown
        menu={{
          items: orderOptions,
          onClick: handleMenuClick,
        }}
        placement="bottomRight"
      >
        <img src={ThreeDotsHrz} style={{ width: "25px", cursor: "pointer" }} />
      </Dropdown>
    </>
  );
};

export default OrderDropDown;
